/**
 * Discriminador polimórfico usado en EntityKeyword, AclEntry, FileAsset, History, Favorite.
 * Reemplaza el campo `obj` del original (tb_acl.obj, tb_keyword.obj, tb_file.obj, etc).
 */
export const OwnerType = {
  ACCOUNT: 'ACCOUNT', // ex tb_contact (UI: "Cuenta")
  PERSON: 'PERSON',
  PROJECT: 'PROJECT',
  ACTIVITY: 'ACTIVITY',
  SALE: 'SALE',
} as const;

export type OwnerType = (typeof OwnerType)[keyof typeof OwnerType];
